import { Button } from '@usealloy/component-library';
import styled, { css, keyframes } from 'styled-components';

export const gentleBlinking = keyframes`
  0% {
    opacity: 0.6;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

export const StyledPendingOpeningParenthesisContainer = styled.div<{ hasPendingOpenParenthesis: boolean }>`
  position: relative;
  display: flex;
  font-family: var(--cl-font-family-mono);
  font-size: var(--cl-font-size-2);
  width: 5px;
  margin-left: -5px;
  padding-left: 5px;
  padding: 3px 1px;
  align-self: baseline;
  transition: width 0.1s ease-in-out;

  &:hover, &:focus-within {
    width: 16px;
    margin-left: -8px;
    padding-left: 7px;
    z-index: 1;
  }

  ${({ hasPendingOpenParenthesis }) => hasPendingOpenParenthesis && css`
    width: 15px;
    margin-left: -5px;
    padding-left: 5px;
    z-index: 1;
  `}
`;

export const StyledPendingOpeningParenthesisDropdown = styled.div<{ hasPendingOpenParenthesis: boolean }>`
  display: flex;
  flex-shrink: 0;
  font-weight: bold;
  border-radius: var(--cl-radius-1);
  color: var(--cl-text-default);
  font-weight: bold;
  max-width: 3px;
  margin: 0;

  > div {
    display: flex;
    align-items: center;
  }

  &:hover, &:focus-within {
    max-width: 15px;
    z-index: 1;
  }

  &:hover {
    background-color: var(--cl-yellow-200);
  }

  &:focus-within {
    background-color: var(--cl-yellow-200);
    
  }

  ${({ hasPendingOpenParenthesis }) => hasPendingOpenParenthesis && css`
    animation: ${gentleBlinking} 1000ms ease infinite;
    max-width: 15px;
    z-index: 1;
  `}
`;

export const StyledHoverButton = styled(Button)`
  && {
    color: var(--cl-gray-500);
    font-weight: var(--cl-font-weight-medium);
    padding: 0;
    margin-left: var(--cl-space-2);
  }
`;
